import React, { useState, useEffect } from 'react';
import ExecutiveSummary from './components/ExecutiveSummary';
import NextSession from './components/NextSession';
import ReadinessDashboard from './components/ReadinessDashboard';
import WeeklyCalendar from './components/WeeklyCalendar';
import LastSession from './components/LastSession';
import RecoveryAnalysis from './components/RecoveryAnalysis';
import LoadDistribution from './components/LoadDistribution';
import TrendsCharts from './components/TrendsCharts';

function App() {
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // In development, we might need to mock this or ensure the proxy works
    fetch('/api/report/json')
      .then(res => {
        if (!res.ok) throw new Error('Failed to fetch report data');
        return res.json();
      })
      .then(data => {
        setReportData(data);
        setLoading(false);
      })
      .catch(err => {
        console.error("Error fetching report:", err);
        setError(err.message);
        setLoading(false);
      });
  }, []);

  if (loading) return (
    <div className="flex items-center justify-center min-h-screen bg-gray-900 text-white">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-orange-500"></div>
    </div>
  );

  if (error) return (
    <div className="flex items-center justify-center min-h-screen bg-gray-900 text-red-400">
      Error: {error}
    </div>
  );

  if (!reportData) return null;

  return (
    <div className="min-h-screen bg-gray-900 text-white p-4 md:p-8 font-sans">
      <div className="max-w-7xl mx-auto space-y-6">
        
        {/* Header */}
        <header className="flex justify-between items-center pb-6 border-b border-gray-800">
          <div>
            <h1 className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-orange-400 to-pink-600">
              Running Coach AI
            </h1>
            <p className="text-gray-400 text-sm">
              Generated: {new Date(reportData.generatedAt).toLocaleString()}
            </p>
          </div>
          <div className="text-right">
             <span className="px-3 py-1 bg-gray-800 rounded-full text-xs text-gray-400">
               v{reportData.version}
             </span>
          </div>
        </header>

        {/* Executive Summary */}
        <ExecutiveSummary data={reportData.executiveSummary} />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
           {/* Row 1: Key Session & Readiness */}
           <NextSession data={reportData.nextSession} />
           <ReadinessDashboard data={reportData.readiness} />
           <RecoveryAnalysis data={reportData.recoveryAnalysis} />
           
           {/* Row 2: Recent Activity & Load */}
           <LastSession data={reportData.lastSession} />
           <LoadDistribution data={reportData.loadDistribution} />
           
           {/* Row 3: Full Width Calendar & Trends */}
           <div className="col-span-1 md:col-span-2 lg:col-span-3 space-y-6">
               <WeeklyCalendar 
                  weeklyLog={reportData.weeklyLog} 
                  summary={reportData.loadDistribution} 
                  settings={reportData.settings} 
               />
               <TrendsCharts data={reportData.trends} settings={reportData.settings} />
           </div>
        </div>

      </div>
    </div>
  );
}

export default App;
